import gql from 'graphql-tag';

export const SEND_OCA_LINK = gql`
  mutation SendOcaLink($input: SendOcaLinkInput!) {
    result: sendOcaLink(input: $input) {
      error
      entity
      success
    }
  }
`;
